import { z } from 'zod';
import { eventSchema } from './envelope';

export const FORMS_SUBMISSION_CREATED_V1 = 'forms.submission.created.v1' as const;
export const FORMS_SUBMISSION_DECIDED_V1 = 'forms.submission.decided.v1' as const;

/**
 * Er is een formulier ingediend.
 *
 * **Zonder de ingevulde waarden** (ADR-0038). Een verlofaanvraag draagt een reden, een
 * ziekmelding draagt meer, en een foto van een defect kan een kenteken bevatten. Wat erin stond,
 * leest de behandelaar in het formulier zelf — na zijn aanmelding, en achter zijn recht.
 *
 * Wél mee: wie moet behandelen. `notifications` schrijft daar de inboxregels van, en kan die
 * vraag zelf niet beantwoorden — het antwoord hangt aan de instelling van het formulier en aan
 * een groepslidmaatschap, en dat zijn gegevens van andere modules.
 */
export const submissionCreatedV1Schema = eventSchema({
  submissionId: z.guid(),
  formId: z.guid(),
  formVersionId: z.guid(),
  /** De titel van het formulier: "Verlofaanvraag". Geen inhoud, wel een onderwerp. */
  formTitle: z.string(),
  personId: z.guid(),
  /** Leeg bij een formulier zonder behandeling. */
  handlerIds: z.array(z.guid()),
});
export type SubmissionCreatedV1 = z.infer<typeof submissionCreatedV1Schema>;

/**
 * Er is beslist.
 *
 * `status` gaat mee omdat de melding aan de inzender ervan afhangt — "goedgekeurd" en "afgewezen"
 * zijn twee verschillende berichten, en dat onderscheid is geen inhoud maar de uitkomst. De
 * **nota** gaat niet mee: dat is de uitleg van de behandelaar, en die hoort in het formulier.
 */
export const submissionDecidedV1Schema = eventSchema({
  submissionId: z.guid(),
  formId: z.guid(),
  formTitle: z.string(),
  /** De inzender: hij krijgt de melding. */
  personId: z.guid(),
  status: z.enum(['approved', 'rejected']),
  decidedBy: z.guid(),
});
export type SubmissionDecidedV1 = z.infer<typeof submissionDecidedV1Schema>;

export const formsEventCatalog = {
  [FORMS_SUBMISSION_CREATED_V1]: submissionCreatedV1Schema,
  [FORMS_SUBMISSION_DECIDED_V1]: submissionDecidedV1Schema,
} as const;
